<script lang="ts">
    import Logo from '$lib/components/assets/Logo.svelte';
    import {getContext} from 'svelte';
    import {keyIsNativePlatform} from '$lib/context-keys';
    import {replaceState} from '$app/navigation';

    const isNativePlatform = getContext(keyIsNativePlatform)

    function handleReload() {
        if (isNativePlatform) {
            replaceState(window.location.origin, {}) // reload on subroute not possible on mobile
        }
        location.reload() //.reload since, other than by window.location.href, cache is used
    }
</script>

<div id="remote-changes-wrapper">
    <div>

        <Logo size="midi"/>

        <p>
            Changes were detected from a different tab or device. Please
        </p>

        <button on:click={handleReload}>Reload »</button>

    </div>
</div>

<style>
    #remote-changes-wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        background: var(--color-light);
    }

    #remote-changes-wrapper > div {
        display: flex;
        flex-direction: column;
        align-items: center;
        transform: translateY(-10vh);
        /*border: 1px solid magenta;*/
    }

    p {
        margin: 2rem 0;
        text-align: center;
        max-width: 26ch;
    }

    button {
        padding: .8rem 1rem;
        font-weight: var(--font-emph);
        background: var(--color-accent);
        color: white;
    }


</style>